import { MapPinOff } from "lucide-react";
import { Button } from "@/components/ui/button";
import { useCaptureLocation } from "@/hooks/use-capture";

/**
 * Shown while the phone has no position and location is not on: denied, unavailable, or a
 * prompt the crew dismissed. A denied site cannot be asked again, so it says where to fix it.
 */
export function LocationNotice() {
  const { status, position, request } = useCaptureLocation();
  // "unknown" is the moment before the permission check answers; nothing is wrong yet.
  if (position || status === "granted" || status === "unknown") return null;

  return (
    <div
      role="status"
      data-testid="location-notice"
      className="flex items-start gap-3 rounded-lg border bg-card p-3"
    >
      <MapPinOff className="mt-0.5 size-5 shrink-0 text-muted-foreground" />
      <div className="min-w-0 flex-1 space-y-2">
        <p className="text-sm">Location is off. Photos will not be pinned on the map.</p>
        {status === "denied" ? (
          <p className="text-sm text-muted-foreground">
            Turn it on for this site in your browser settings.
          </p>
        ) : (
          <Button variant="outline" size="sm" onClick={request}>
            Turn on location
          </Button>
        )}
      </div>
    </div>
  );
}
